import { useState } from 'react';
import { f as fontSize, d as InputButton, s as spacing, I as Input, i as iconSize, S as Spacer, E as ErrorMessage } from './basic-72632cb3.browser.esm.js';
import styled from '@emotion/styled';
import { ArrowRightIcon } from '@radix-ui/react-icons';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

const TextDivider = styled.div`
  display: flex;
  align-items: center;
  color: ${p => p.theme.text.secondary};
  font-size: ${fontSize.sm};
  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid ${p => p.theme.bg.elevated};
  }

  span {
    margin: 0 1rem;
  }
`;

function InputSelectionUI(props) {
  const [input, setInput] = useState("");
  const singleWallet = props.supportedWallets.length === 1;
  const [error, setError] = useState();
  const [showError, setShowError] = useState(false);
  const handleSelect = () => {
    setShowError(true);
    if (!input || !!error) {
      return;
    }
    props.onSelect(input);
  };
  const renderingError = showError && !!error || !input && !!props.emptyErrorMessage && showError;
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsxs("div", {
      style: {
        position: "relative"
      },
      children: [/*#__PURE__*/jsx(Input, {
        placeholder: props.placeholder,
        variant: "secondary",
        type: props.type,
        name: props.name,
        value: input,
        "data-error": renderingError,
        onChange: e => {
          setInput(e.target.value);
          if (props.errorMessage) {
            setError(props.errorMessage(e.target.value));
          } else {
            setError(undefined);
          }
        },
        onKeyDown: e => {
          if (e.key === "Enter") {
            handleSelect();
          }
        }
      }), /*#__PURE__*/jsx(CircleInputButton, {
        onClick: () => {
          handleSelect();
        },
        color: "inverted",
        type: "button",
        children: /*#__PURE__*/jsx(ArrowRightIcon, {
          width: iconSize.sm,
          height: iconSize.sm
        })
      })]
    }), showError && error && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Spacer, {
        y: "xs"
      }), /*#__PURE__*/jsx(ErrorMessage, {
        children: error
      })]
    }), !(showError && error) && !input && props.emptyErrorMessage && showError && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Spacer, {
        y: "xs"
      }), /*#__PURE__*/jsx(ErrorMessage, {
        children: props.emptyErrorMessage
      })]
    }), !singleWallet && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Spacer, {
        y: "lg"
      }), /*#__PURE__*/jsx(TextDivider, {
        children: /*#__PURE__*/jsx("span", {
          children: " OR "
        })
      }), /*#__PURE__*/jsx(Spacer, {
        y: "md"
      })]
    })]
  });
}
const CircleInputButton = styled(InputButton)`
  background: ${p => p.theme.bg.highlighted};
  border-radius: 50%;
  padding: ${spacing.xxs};
  color: ${p => p.theme.text.neutral};
  position: absolute;
  top: 50%;
  right: ${spacing.sm};
  transform: translateY(-50%);
  &:hover {
    color: ${p => p.theme.text.neutral};
  }
`;

export { InputSelectionUI as I, TextDivider as T };
